var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.5V17.5H14.1C15.15 17.5 16.0625 17.1667 16.8375 16.5C17.6125 15.8333 18 15 18 14C18 13 17.6125 12.1667 16.8375 11.5C16.0625 10.8333 15.15 10.5 14.1 10.5H7.8L10.4 13.1L9 14.5L4 9.5L9 4.5L10.4 5.9L7.8 8.5H14.1C15.7167 8.5 17.1042 9.025 18.2625 10.075C19.4208 11.125 20 12.4333 20 14C20 15.5667 19.4208 16.875 18.2625 17.925C17.1042 18.975 15.7167 19.5 14.1 19.5H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUndo);
export default __webpack_public_path__ + "static/media/ico-undo.631869ef54e38f449fab41fe938bb639.svg";
export { ForwardRef as ReactComponent };